export const defaultProblemLabels = ['anxiety', 'relationships', 'grief', 'loneliness', 'motivation', 'health', 'school/work', 'identity', 'other'];

export const defaultProblemStatuses = ['unknowns', 'working on it', 'needs ideas', 'has support', 'resolved', 'helping others'];

export const problemDraftStorageKey = 'cyberautography:problemDraft';

const problemSourceLimits = {
  title: 180,
  sourceTitle: 500,
  sourceText: 5000,
};

function limitText(value, max) {
  return String(value || '').trim().slice(0, max);
}

export function normalizeProblemChip(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ').slice(0, 80);
}

export function normalizeProblemChips(values, fallback) {
  const normalized = (Array.isArray(values) ? values : [values])
    .map(normalizeProblemChip)
    .filter(Boolean);
  return [...new Set(normalized)].slice(0, 20).length ? [...new Set(normalized)].slice(0, 20) : fallback;
}

export function buildProblemSourceDraft(source) {
  const title = limitText(source?.sourceTitle || source?.prompt, problemSourceLimits.sourceTitle);
  const text = limitText(source?.sourceText || source?.answer, problemSourceLimits.sourceText);
  return {
    title: title ? `Problem from: ${title}`.slice(0, problemSourceLimits.title) : '',
    problem: text,
    sourceType: source?.sourceType || 'pageEntry',
    sourceId: source?.sourceId || source?.id || '',
    sourceTitle: title,
    sourceText: text,
  };
}
